import { cn } from 'clsx-for-tailwind';
import { Icon } from '@iconify/react';
import { ReactNode } from 'react';

export interface NavigationButtonProps {
  icon: string;
  label: string;
  id: string;
  onClick: () => void;
  active?: boolean;
  children?: ReactNode;
}

export const NavigationButton = ({
  icon,
  label,
  id,
  onClick,
  active = false,
  children,
}: NavigationButtonProps) => {
  const button = (
    <button
      className={cn(
        'flex !h-fit !w-[60px] items-center justify-center !bg-transparent !px-2.5 !py-2 font-sans !text-lg !font-semibold !text-white md:!h-12 md:!w-[65px] md:!gap-0.5 md:!px-3.5 md:!text-sm xl:!w-[40px] 2xl:!w-[80px] xl:!font-medium',
        {
          '!text-[#FCCB16]': active,
          'hover:!text-[#FCCB16]': !active,
        }
      )}
      style={{ fontFamily: "'Noto Sans', sans-serif" }}
      onClick={onClick}
      id={id}
    >
      <div className='flex flex-col items-center justify-center gap-0.5'>
        <Icon icon={icon} className='iconify size-8' />
        <span className='hidden 2xl:block whitespace-nowrap text-xs xl:text-sm'>{label}</span>
      </div>
    </button>
  );

  if (active) {
    return (
      <>
        <div className='relative flex h-[62px] items-center'>
          {button}
          <div className='absolute bottom-0 left-0 right-0 h-0.5 bg-[#FCCB16]' />
        </div>
        {children}
      </>
    );
  }

  return (
    <>
      {button}
      {children}
    </>
  );
};

export default NavigationButton;
